import { render, staticRenderFns } from "./consultDetails.vue?vue&type=template&id=2c78798a&scoped=true&"
import script from "./consultDetails.vue?vue&type=script&lang=js&"
export * from "./consultDetails.vue?vue&type=script&lang=js&"
import style0 from "./consultDetails.vue?vue&type=style&index=0&id=2c78798a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c78798a",
  null
  
)

export default component.exports